// extracted by mini-css-extract-plugin
export default {"hero_card":"Hero_hero_card__BEerN","hero_home":"Hero_hero_home__SsU2-"};